export const FALLBACK_LOCALE = 'en';
//# sourceMappingURL=constants.js.map